import { ApiBase } from '@/api/api'
import { makeDeleteRequest } from '@/api/fetchCalls'

export const deleteCompletePageConditionalRuleById = async (
  id: string
): Promise<void> => {
  return makeDeleteRequest(ApiBase + `/workflows/redirect-rules/${id}`)
}
